export const id2xy = Core.id2xy;
export const xy2id = Core.xy2id;

export function formatCoordinates({ x, y }) {
    return `( ${x} | ${y} )`;
}

export function formatCoordinatesShort({ x, y }) {
    return `${x}|${y}`;
}
